import { useContent, html } from '@/content';

export default function AboutSection() {
  const c = useContent();
  return (
    <section id="about" className="py-20 md:py-28 bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Text Content */}
          <div className="order-2 lg:order-1">
            <div className="animate-on-scroll">
              <p className="text-xs tracking-[0.3em] uppercase text-champagne-500 font-medium mb-3">
                {c.about.eyebrow}
              </p>
              <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-gray-800 mb-6 leading-tight">
                {c.about.title}
              </h2>
            </div>

            <div className="space-y-5 text-gray-600 leading-relaxed">
              <p className="animate-on-scroll delay-100">{c.about.p1}</p>
              <p className="animate-on-scroll delay-200">{c.about.p2}</p>
              <p className="animate-on-scroll delay-300">{c.about.p3}</p>
              <p className="animate-on-scroll delay-400" {...html(c.about.p4)} />
            </div>
          </div>

          {/* Portrait Photo */}
          <div className="order-1 lg:order-2 flex justify-center animate-on-scroll-scale">
            <div className="relative">
              <div className="w-72 md:w-80 lg:w-96 rounded-2xl overflow-hidden">
                <img
                  src="https://static.readdy.ai/image/62e59b4a12706970a459027b4a407756/8e5bf834f054ecd4aeffc3d75437c4d0.jpeg"
                  alt="Sonja Karmann – Diplom-Kosmetikerin, Gesichtszauber"
                  title="Sonja Karmann – Diplom-Kosmetikerin im Kosmetikstudio Gesichtszauber Wertingen"
                  className="w-full h-auto object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 w-20 h-20 rounded-full bg-champagne-200/50 blur-xl"></div>
              <div className="absolute -top-4 -left-4 w-16 h-16 rounded-full bg-blush-200/50 blur-xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}